import { ROUTES } from '@/lib/routes';

/** A nav entry that always links somewhere (no dropdown grouping). */
export interface NavLeaf {
  label: string;
  path: string;
}

export interface NavItem {
  label: string;
  /** Destination. Omitted for items that only group `children` in a dropdown. */
  path?: string;
  /** When present, the item renders as a dropdown of sub-links. */
  children?: readonly NavLeaf[];
}

/** Primary navigation — shown in Navbar (desktop + mobile overlay) */
export const PRIMARY_NAV: readonly NavItem[] = [
  { label: 'Home', path: ROUTES.home },
  { label: 'Nossos Diferenciais', path: ROUTES.nossosDiferenciais },
  { label: 'Nossa Essência', path: ROUTES.nossaEssencia },
  { label: 'Como Funciona', path: ROUTES.comoFunciona },
  { label: 'Privacidade', path: ROUTES.privacidade },
  { label: 'Seja Nosso Parceiro', path: ROUTES.sejaNossoParceiro },
  {
    label: 'Contato',
    children: [
      { label: 'Negocie com a gente', path: '/#contact' },
      { label: 'Trabalhe Conosco', path: ROUTES.trabalheConosco },
      { label: 'Denúncia', path: ROUTES.denuncia },
    ],
  },
] as const;

/** Secondary routes surfaced in footer + contextual CTAs */
export const SECONDARY_NAV: readonly NavLeaf[] = [
  { label: 'Guia de Direito dos Titulares', path: ROUTES.guiaDireitoTitulares },
] as const;

/** Footer-only links (legal) */
export const FOOTER_LEGAL: readonly NavLeaf[] = [
  { label: 'Termos de Uso', path: ROUTES.termosDeUso },
] as const;
